var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMixNMatchBundleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 6,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5009 27.831C36.1094 29.2117 33.0514 28.3923 31.6707 26.0008C30.29 23.6094 31.1094 20.5514 33.5009 19.1707C35.8924 17.79 38.9502 18.6094 40.331 21.0008C41.7117 23.3923 40.8924 26.4502 38.5009 27.831Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6707 51.0009C33.0514 53.3924 36.1094 54.2117 38.5009 52.831C40.8924 51.4504 41.7117 48.3924 40.331 46.0009C38.9502 43.6094 35.8924 42.79 33.5009 44.1707C31.1094 45.5515 30.29 48.6094 31.6707 51.0009Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0839 32.2958C22.5524 33.18 22.0276 35.1383 22.9119 36.6698C23.7193 38.0683 25.4417 38.6467 26.9296 38.019L43.7704 30.9138C46.807 29.6326 50.3225 30.8132 51.9706 33.6675C53.7752 36.7933 52.7042 40.7903 49.5784 42.595L45.4954 44.9523C44.6982 45.4125 43.6789 45.1395 43.2187 44.3423C42.7585 43.5452 43.0315 42.5258 43.8287 42.0657L47.9117 39.7083C49.4432 38.824 49.968 36.8657 49.0837 35.3342C48.2764 33.9357 46.5539 33.3573 45.066 33.985L28.2253 41.0902C25.1886 42.3713 21.6731 41.1908 20.0251 38.3365C18.2204 35.2107 19.2914 31.2137 22.4172 29.409L26.5002 27.0517C27.2974 26.5915 28.3167 26.8646 28.7769 27.6617C29.2372 28.4589 28.964 29.4782 28.1669 29.9384L24.0839 32.2958Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixNMatchBundleIcon);
export default __webpack_public_path__ + "static/media/mix-n-match-bundle-icon.5d15d640eb5d20b88c9a7644b7d7180e.svg";
export { ForwardRef as ReactComponent };